/**
 * React component for rendering the calendar views and popups
 */
import React from "react";
import queryString from "qs";
import {Popup} from "./Popup";
import {Months} from "./Months";
import {Filter} from "./Filter";
import {
  addRangeToEvents,
  getFilteredEvents,
  addUserCalendarToCookies,
  useStateValue,
} from "../App";
import {ActionBar} from "./ActionBar";
import {CalendarJumper} from "./CalendarJumper";
// import { useScrollPosition } from "@n8tb1t/use-scroll-position";

// On mobile (hardcoded 991px) the "month" view is not available
const availableViews =
    window.innerWidth < 991
        ? ["smallMonth", "year"]
        : ["smallMonth", "month", "year"];

/**
 * Main Calendar component/
 */
export const Calendar = ({
                           filterList,
                           filterGroups,
                           moment,
                           createCalendarFlag,
                           setCreatingCalendar,
                         }) => {
  const [state, dispatch] = useStateValue();

  // I don't know if this shoud be here, but it's here now so...
  // It's a Google Tagmanager action
  React.useMemo(() => {
    window.dataLayer.push({
      event: "loadWithCalendarView",
      view: state.view,
    });
  }, []);

  React.useEffect(() => {
    if (createCalendarFlag === true) {
      createCalendar(null, null);
    }
  }, [createCalendarFlag]);

  // Get all the events from de data attribute
  const events = addRangeToEvents(JSON.parse(calendar.dataset.events));

  // Get all the userEvents from de data attribute
  const [userEvents, updateUserEvents] = React.useState(
      addRangeToEvents(JSON.parse(calendar.dataset.userEvents))
  );

  // Manage popup state
  // Maybe the popup can be a different component
  const [popupActive, setPopupActive] = React.useState(false);
  const [popupDate, updatePopupDate] = React.useState(moment());
  const [popupPosition, updatePopupPosition] = React.useState({
    top: 0,
    left: 0,
  });

  const [filterPopupActive, setFilterPopupActive] = React.useState(false);
  /**
   * Method for opening a popup
   * Event is the native browser event
   */
  const openPopup = (day, event, element) => {
    // Update the popup location before setting is to an active state
    const parentDiv = document.querySelector('.container.content.section');
    const parentDim = parentDiv.getBoundingClientRect();
    const relativePos = {};
    const target = event ? event.target : element;
    const dim = target.getBoundingClientRect();
    const popupDim = document
        .querySelector(".calendar__popup")
        .getBoundingClientRect();


    relativePos.top = dim.top - parentDim.top,
        relativePos.right = (dim.right - parentDim.right),
        relativePos.bottom = dim.bottom - parentDim.bottom,
        relativePos.left = (dim.left - parentDim.left);

    let windowWidth = window.innerWidth;
    if(windowWidth >= 1140){
      windowWidth = 1140;
    }
    updatePopupPosition({
      top: `${relativePos.top + dim.height / 2 - 50}px`,
      left:
          relativePos.left > windowWidth / 2
              ? `${relativePos.left - popupDim.width}px`
              : `${relativePos.left + 30}px`,
    });

    // Update the popup date
    updatePopupDate(day.date);

    // Set is to active
    setPopupActive(true);
  };

  // Vanish popup, get out of here!
  const closePopup = () => {
    setPopupActive(false);
  };

  React.useEffect(() => {
    if (availableViews.indexOf(state.view) === -1) {
      changeView("smallMonth");
    }
  }, []);

  // Change the view (if available) and set is as a query parameter
  const changeView = (view) => {
    if (availableViews.indexOf(view) > -1) {
      dispatch({type: "updateView", payload: view});

      // Create the updated query
      const updatedQuery = {
        ...queryString.parse(window.location.search.replace("?", "")),
        view: view,
      };

      // Create the new url and push it into the history API
      const newUrl = `${window.location.origin}${
          window.location.pathname
      }?${queryString.stringify(updatedQuery)}`;

      window.history.pushState({}, "", newUrl);

      window.dataLayer.push({
        event: "switchCalendarView",
        view: view,
      });

      setTimeout(() => {
        let m = moment(new Date(), "M").format("MMMM");
        const el = document.getElementById(m);
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.scrollY - 180,
          left: 0,
          behavior: "smooth"
        });
      },100);

      // Start syncinc with server when uid is set
      if (state.uid == null) return;

      // Create the body for the request
      const body = queryString.stringify({
        nonce: wp.nonce,
        action: "update_active_calendar_view",
        created_by: state.uid,
        active_view: view,
      });

      // Do nothing with the result (only log errors)
      fetch(wp.ajaxUrl, {
        method: "POST",
        credentials: "same-origin",
        headers: new Headers({
          "Content-Type": "application/x-www-form-urlencoded",
        }),
        body: body,
      }).catch((err) => {
        console.error(err);
      });


    };


  };

  const createCalendar = (event, date, callback) => {
    if (event) {
      event.preventDefault();
    }

    setCreatingCalendar(true);

    const body = queryString.stringify({
      nonce: wp.nonce,
      action: "create_custom_calendar",
      year: state.year,
      active_filter_groups: JSON.stringify([...state.activeFilterGroups, "0"]),
      active_filters: JSON.stringify(state.activeFilters),
      active_view: state.view,
    });

    // Fetch yo
    fetch(wp.ajaxUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
    })
        .then((res) => res.json())
        .then((res) => {
          if (res.uid) {
            // Add it to cookies (because we don't have a login system)
           // addUserCalendarToCookies({uid: res.uid, year: state.year});
            //const newUrl = `${window.location.origin}/agenda/bekijk/${res.uid}?created=true${
            //    date === null ? "" : `&date=${date.format("DD-MM-YYYY")}`
            //}`;
            //window.location = newUrl;
          }
        })
        .catch((err) => {
          callback(err);
        });
  };

  /**
   * Create a custom item
   */
  const createItem = (event, {title, startDate, endDate, startTime, endTime, notes, eventDel, repeat, repeatDuration}, callback) => {
    event.preventDefault();

    const created_by = state.uid == null ? false : state.uid;
    if(repeatDuration === null || repeatDuration === undefined || repeatDuration === "" || repeatDuration === "0" || repeatDuration === 0){
        repeatDuration = 1;
        if(repeat === "daily") {
          repeatDuration = 2;
        }
    }
    console.log(eventDel);
    // Create the body of the request
    const body = queryString.stringify({
      nonce: wp.nonce,
      action: "create_custom_calendar_item",
      title: title,
      start_date: startDate,
      end_date: endDate,
      created_by: created_by,
      year: state.year,
      start_time: startTime,
      end_time: endTime,
      notes: notes,
      repeat: repeat,
      repeat_duration: repeatDuration,
      eventDel: eventDel?.id,
    });
    console.log(body);

    // Fetch yo
    fetch(wp.ajaxUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
    })
        .then((res) => res.json())
        .then((res) => {
          // Popuplate the events with ranges
          const eventsWithRange = addRangeToEvents(res.events);

          // Update the state
          updateUserEvents(eventsWithRange);

          window.dataLayer.push({
            event: `createCalendarItem`,
            calendarItemName: title,
          });

          dispatch({type: "addFilterGroupToActiveFilters", payload: "0"});

          closePopup();

          callback(res);
        })
        .catch((err) => {
          callback(null, err);
        });
  };

  /**
   * Remove an item from a userCalendar
   * I don't think it's a good idea to let every user delete every item but this was not my call
   */
  const removeItem = (event, {id, created_by}, callback) => {
    event.preventDefault();

    // Create the body
    const body = queryString.stringify({
      nonce: wp.nonce,
      action: "delete_custom_calendar_item",
      id: id,
      created_by: created_by,
    });

    // Fetch yo
    fetch(wp.ajaxUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: new Headers({
        "Content-Type": "application/x-www-form-urlencoded",
      }),
      body: body,
    })
        .then((res) => res.json())
        .then((res) => {
          // Remove the event from the state
          updateUserEvents((userEvents) => userEvents.filter((e) => e.id !== id));

          window.dataLayer.push({
            event: `removeCalendarItem`,
            calendarItemName: title,
          });

          callback(res);
        })
        .catch((err) => {
          callback(null, err);
        });
  };

  /*
   * This object is used by the calendar view, not the popup
   * It only contains the events matching the filters
   */
  const filteredEvents = React.useMemo(() =>
      getFilteredEvents([...events, ...userEvents], {
        activeFilterGroups: state.activeFilterGroups,
        activeFilters: state.activeFilters,
        activeSubtractions: state.activeSubtractions,
      })
  );
  // Finally let's render some components!
  // No state management yet, just pass all the props
  return (
      <>
        <ActionBar
            availableViews={availableViews}
            view={state.view}
            changeView={changeView}
            openFilterPopup={() => setFilterPopupActive(true)}
            filteredEvents={filteredEvents}
            year={state.year}
            uid={JSON.parse(calendar.dataset.userCalendar).edit_hash}
            euid={JSON.parse(calendar.dataset.userCalendar).created_by}
        />

        {window.innerWidth < 991 ? (
            <>
              <Filter
                  filterList={filterList}
                  filterGroups={filterGroups}
                  isActive={filterPopupActive}
                  setIsActive={setFilterPopupActive}
              />

              {state.view != "year" || (state.uid !== null && state.uid !== '') ? (
                  <CalendarJumper moment={moment} view={state.view}/>
              ) : (<></>)
              }
            </>
        ) : (
            <div
                className={`calendar__stickyBar`}
                style={{
                  position: "sticky",
                  top: 0,
                  zIndex: 99,
                }}
            >
              <Filter filterList={filterList} filterGroups={filterGroups}/>
              {state.view != "year" || (state.uid !== null && state.uid !== '') ? (
                  <CalendarJumper moment={moment} view={state.view}/>
              ) : (<></>)
              }

            </div>
        )}

        <div className={`calendar calendar--${state.view}${state.view != "year" || (state.uid !== null && state.uid !== '')?'':'--simple'}`} id="printable">
          <Months
              view={state.view}
              events={filteredEvents}
              openPopup={openPopup}
              year={state.year}
              canCreateItems={state.uid !== null && state.uid !== ''}
          />
        </div>

        <Popup
            active={popupActive}
            events={filteredEvents}
            userEvents={userEvents}
            close={closePopup}
            date={popupDate}
            position={popupPosition}
            createItem={createItem}
            setPopupActive={setPopupActive}
            removeItem={removeItem}
            canCreateItems={state.uid !== null && state.uid !== ''}
            createCalendar={createCalendar}
        />

        {/* <CalendarJumper moment={moment} view={"side"} /> */}
      </>
  );
};
